<div class="login-container">
  <div class="login-container-body">
    <form [formGroup]="loginForm" (ngSubmit)="doLogin($event)">
      <cowing-input
        [iconShow]="true"
        [iconName]="'mail'"
        [isForm]="true"
        [fixedIcon]="true"
        [placeholder]="'login.email' | translate"
        [control]="loginForm.get('email')"
      >
      </cowing-input>
      <cowing-input
        [type]="'password'"
        [iconShow]="true"
        [iconName]="'lock'"
        [fixedIcon]="true"
        [isForm]="true"
        [placeholder]="'login.password' | translate"
        [control]="loginForm.get('password')"
      >
      </cowing-input>
      <div class="login-container-button">
        <cowing-button
          [isSubmit]="true"
          [label]="'login.continue' | translate"
          (event)="doLogin($event)"
          [iconShow]="false"
          [iconName]="'arrowRight'"
          [disabled]="!loginForm.valid"
        >
        </cowing-button>
        <p class="error-message" *ngIf="error !== ''">{{ error }}</p>
      </div>
    </form>
  </div>

  <div class="login-container-recovery" (click)="doPwdRecovery()">
    {{ "login.forgot" | translate }}
  </div>
</div>
